import { useSearchParams } from "react-router-dom";
import ClinicUsers from "../../../contexts/ClinicUsers";
import useUser from "../../../hooks/useUser";
import DesktopUserListingPage, {
  userTableParams,
} from "./DesktopUserListingPage";
import { useGetUsersTable } from "./hooks/useGetUsersTable";

export default function UsersView() {
  const [searchParams] = useSearchParams();
  const { preferance } = useUser();
  const page = parseInt(searchParams.get(userTableParams.page)) || 0;
  const size =
    parseInt(searchParams.get(userTableParams.rowsPerPage)) ||
    Number(preferance?.clinicUsersTableRowsPerPage) ||
    10;
  const q = searchParams.get(userTableParams.wildcard) || "";
  const sortParam = searchParams.get("sort") || "";
  const sort = sortParam ? sortParam : "id=asc";

  const { data, isLoading, error } = useGetUsersTable(
    page,
    size,
    q,
    sort,
    null,
    null,
    null,
    null
  );

  return (
    <ClinicUsers data={data} loading={isLoading} error={error}>
      <DesktopUserListingPage />
    </ClinicUsers>
  );
}
